import React, { useState } from 'react';
import Graph from './components/graph.js';
import Info from './components/info.js';
import { xToY } from './components/xToY.js';

function App() {
  const [userData, setUserData] = useState({
    labels: '',
    datasets: [{
      label: 'Class Scores',
      data: xToY,
      backgroundColor: ['black']
    }]
  });
  const handleEnter = () => {
    let score = document.getElementById('score').value;
    if (score > 100) score = 100;
    if (score < 0) score = 0;
    const amount = document.getElementById('amount').value;
    xToY[score] += parseInt(amount, 10);
    setUserData({
        labels: '',
        datasets: [{
          label: 'Class Scores',
          data: xToY,
          backgroundColor: ['black']
        }]
    })
  }
  window.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') handleEnter();
  });
  return (
    <>
    <div style={{display: 'inline'}}>
        <div>Insert Scores</div>
        <input id='score'/>
        <button onClick={handleEnter}>Enter</button>
      </div>
      <div style={{display: 'inline'}}>
        <div>Amount</div>
        <input id='amount' defaultValue={1}/>
      </div>
    <div className="App" style={{display: 'flex'}}>
      <div style={{width: '80%'}}><Graph chartData={userData}/></div>
      <div style={{width: '20%'}}><Info allPoints={xToY}/></div>
    </div>
    </>
  );
}

export default App;
